var AppDispatcher = require('../core/AppDispatcher.jsx');
var ActionTypes = require('../constants/SelectCustomerConstants.js').ActionTypes;
var DCActionTypes = require('../constants/DigitalConsentConstants.js').ActionTypes;
var ApplicationActionTypes = require('../constants/ApplicationConstants.js').ActionTypes;

module.exports = {
    clientRetrieveStarted: function (clientOin) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLIENT_RETRIEVE_STARTED,
            clientOin
        })
    },

    clientRetrieveFailed: function (clientOin) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLIENT_RETRIEVE_FAILED,
            clientOin
        })
    },

    clientRetrieveCompleted: function (client) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLIENT_RETRIEVE_COMPLETED,
            client
        })
    },

    setClientSearchResult: function (result) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLIENT_SEARCH_COMPLETED,
            result: result
        })
    },

    setApplicationLinkType: function (applicationLinkType) {
        AppDispatcher.dispatch({
            actionType: ApplicationActionTypes.SET_APPLICATION_LINK_TYPE,
            applicationLinkType
        });
    },

    verifyMobileNumberResult: function (result) {
        AppDispatcher.dispatch({
            actionType: DCActionTypes.RECEIVED_VERIFY_MOBILE_NUMBER_RESULT,
            result: result
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/ClientApiCallbackActions.js